import React from 'react';

export const EVENTS_PER_PAGE = 4;

export const useExpandedEvents = <T extends string | number>() => {
    const [expandedCounts, setExpandedCounts] = React.useState<Map<T, number>>(new Map());

    const getVisibleCount = (key: T): number => expandedCounts.get(key) ?? EVENTS_PER_PAGE;

    const handleShowMore = (key: T, totalCount: number): void => {
        setExpandedCounts((prev) => {
            const next = new Map(prev);
            const current = next.get(key) ?? EVENTS_PER_PAGE;
            next.set(key, current === totalCount ? EVENTS_PER_PAGE : totalCount);
            return next;
        });
    };

    return { getVisibleCount, handleShowMore };
};

export const isGolf = (sportId: string): boolean => sportId === 'golf';
